import React, { useMemo, useState } from 'react';
import { Modal, ModalProps } from '@vimily/bonjoro-ui-components-v2/Modal';
import { useGlobalEvent } from 'beautiful-react-hooks';
import { TaskCreationForm } from '../TaskCreation/TaskCreationForm';
import { FooterPanel } from './FooterPanel';
import { TaskCreationWrapper } from '../TaskCreation/TaskCreationWrapper';

export const lottieOptions = {
  loop: true,
  autoplay: true,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
};

const taskCreationModalEventName =
  'task-creation-modal::open' as keyof WindowEventMap;

export const openTaskCreationModal = () =>
  window.dispatchEvent(new CustomEvent(taskCreationModalEventName));

export const TaskCreationModal = () => {

  const [open, setOpen] = useState(false);
  const closeModal = () => setOpen(false);
  
  const onOpenTaskCreationModal = useGlobalEvent(taskCreationModalEventName);

  onOpenTaskCreationModal(() => {
    setOpen(true);
  });


  const modalProps = useMemo<ModalProps>(() => {
    return {
      open,
      onModalClose: closeModal,
      className: 'sm:!w-[660px] !rounded-2xl !inset-px !p-0 ]',
      overlayClassName: '!z-[999]',
      closeButtonClassName: '!top-7.5 !right-7.5',
    };
  }, [open]);

  return (
    <TaskCreationWrapper
      onRecordNowSuccess={closeModal}
      onRecordLaterSuccess={closeModal}
    >
      <Modal {...modalProps}>
        <TaskCreationForm title='Send a new message to'/>
        <FooterPanel />
      </Modal>
    </TaskCreationWrapper>
  );
};
